import { FetchResult } from '@apollo/client'
import { ServiceDependencies } from 'lib/core/services/magento'
import { apolloClient } from 'lib/core/services/magento/client'
import gql from 'graphql-tag'
import { jsonToGraphQLQuery } from 'lib/core/resources/helpers/jsonToGraphql'

export interface RemoveWishlistItemMutationObject {
  mutation: {
    removeWishlistItem: {
      __args: {
        input: {
          sku: string
        }
      }
      status: boolean
    }
  }
}

export const removeWishlistItemMutationObject: RemoveWishlistItemMutationObject = {
  mutation: {
    removeWishlistItem: {
      __args: {
        input: {
          sku: ''
        }
      },
      status: true
    }
  }
}

interface RemoveWishlistItemMutationInput {
  sku: string
}

export type RemoveWishlistItemMutation = (input: RemoveWishlistItemMutationInput) => Promise<FetchResult<any>>

export const createRemoveWishlistItemMutation = ({ getMutations }: ServiceDependencies): RemoveWishlistItemMutation => async ({ sku }) => {
  const mutation = getMutations().removeWishlistItemMutation
  mutation.mutation.removeWishlistItem.__args.input.sku = sku

  return apolloClient.mutate({
    mutation: gql`${jsonToGraphQLQuery(mutation)}`
  })
}
